import React from "react";
import { SidebarV1 } from "./components/SidebarV1";

interface AppShellV1Props {
  children: React.ReactNode;
}

/**
 * AppShellV1
 *
 * Page chrome for v1 screens: fixed left sidebar, scrollable content column.
 *
 * This is a separate shell from `DefaultPageLayout`, which the current app uses
 * with a horizontal tab bar inside `DashboardPage`. The two coexist — v1 screens
 * opt into this shell, everything under `/dashboard/*` keeps the old one — so
 * sections can be migrated one at a time instead of in a single risky sweep.
 */
export const AppShellV1: React.FC<AppShellV1Props> = ({ children }) => {
  return (
    <div className="flex h-screen w-full items-start bg-default-background">
      <SidebarV1 />
      <div className="flex h-full grow shrink-0 basis-0 flex-col items-start overflow-y-auto">
        {children}
      </div>
    </div>
  );
};
